import { Check } from "lucide-react";
import { useState } from "react";

const LogForm = ({ goal, onLog }) => {
    const [formData, setFormData] = useState({ logQuantity: 1 });

    const handleSubmit = (event) => {
        event.preventDefault();
        onLog(goal._id, formData.logQuantity);
    };

    return (
        <div>
            <form onSubmit={handleSubmit} className="flex gap-2">
                <input 
                    type="number"
                    value={formData.logQuantity}
                    min="1"
                    max={goal.maxTarget - goal.progress}
                    onChange={(e) => setFormData({ ...formData, logQuantity: parseInt(e.target.value) || 1 })}
                    className="w-1/2 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500" />
                <button type="submit" className="w-1/2 flex-1 flex items-center justify-center gap-1 bg-green-500 text-white px-3 py-2 rounded-lg hover:bg-green-600 transition text-sm">
                    <Check className="w-4 h-4" />
                    Log
                </button>
            </form>
        </div>
    );
};

export default LogForm;
